let divsDesktop = document.getElementsByClassName("boost-pfs-filter-left-col-inner");
let divsMobile = document.getElementsByClassName("boost-pfs-filter-toolbar-top-mobile");

if(window.innerWidth > 767) {
  if (divsDesktop != null && divsDesktop[0] != null) {
  var banner = document.createElement('div');
  banner.innerHTML = "<a href='https://globalteahut.org/pages/teaware-artisans'><img class='teaware-artisans-banner-desktop' src='https://cdn.shopify.com/s/files/1/0311/7288/6667/t/91/assets/teaware-banner-desktop.jpg?v=1713257712' width='210' height'375'/></a>";
  } 
  divsDesktop[0].append(banner);
} else {

  if (divsMobile != null && divsMobile[0] != null) {
    var banner = document.createElement('div');
    banner.innerHTML = "<a href='https://globalteahut.org/pages/teaware-artisans'><img class='mobile-teaware-banner' src='https://cdn.shopify.com/s/files/1/0311/7288/6667/t/91/assets/teaware-banner-mobile.jpg?v=1713257729' width='508' height'213'/></a>";
    banner.style.width = "100%";
    divsMobile[0].append(banner);
  }
  }


